// The Order Details tab's own wording: the card titles, the file states and the
// AI consent headlines. The labels of the facts themselves come from the server
// (OrderBriefPayload).
export const BRIEF_COPY = {
  briefTitle: "Brief & requirements",
  requirements: "Requirements",
  visualTitle: "Visual picks",
  palettes: "Color palettes",
  artStyle: "Art style",
  samples: { cover: "Cover design samples", illustration: "Illustration samples" },
  imageUnavailable: "Image unavailable",
  detailsTitle: "Order Details",
  filesTitle: "Files",
  notAttachedYet: "Not attached yet",
  noneAttached: "None attached",
  pastedText: "Pasted text",
  view: "View",
  hide: "Hide",
  download: "Download",
  aiTitle: "AI consent",
  sensitiveTitle: "Sensitive content",
  nsfw: "Includes NSFW content",
  triggerWarning: "Requires a trigger warning",
  timelineTitle: "Timeline",
  startDate: "Start date",
  expectedDelivery: "Expected delivery",
  toBeConfirmed: "To be confirmed",
  revisionsIncluded: "Revisions included",
  showMore: "Show more",
  showLess: "Show less",
  yes: "Yes",
  no: "No",
}

export const AI_CONSENT_COPY = {
  none: "Freelancers cannot use AI",
  research: "Freelancers may use AI for research and brainstorming",
  all: "Freelancers may:",
  writing: [
    "Adjust tone, phrasing, and style on their own written content",
    "Generate content which they will modify further to ensure depth and originality",
    "Reduce wordiness and repetition and cut down the fluff",
    "Structuring, layout, and planning chapters and the project as a whole",
    "Enrich content and expand on ideas",
    "Basic grammar and spelling checks",
    "Keyword research if applicable",
  ],
  design: [
    "Edit, refine and improve original designs and illustrations",
    "Generate images which they will modify further to ensure originality",
    "Manipulate designs using AI functions such as generative fill, automatic object removal, color replacement and correction, and Style Transfer Effects",
    "Generate text and text effects",
    "Create templates, layouts and storyboards",
    "Use AI generated images as reference",
    "Freelancers are allowed to use AI to analyze design trends and user preferences to create illustrations/designs that resonate with the target audience.",
  ],
}
